import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import Headings from 'admin/components/atoms/Headings';
import { TableRow, TableCell } from 'admin/components/atoms/Tables';
import Labeled from 'admin/components/atoms/Labeled';
import TextBox from 'admin/components/atoms/TextBox';
import { Button } from 'admin/components/atoms/Buttons';
import ConfirmModal from 'admin/components/atoms/ConfirmModal';

import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import LabeledTextBox from 'admin/components/molecules/LabeledTextBox';
import ApiResult from 'admin/components/shared/ApiResult';

import { formatUUID } from 'admin/utils';
import { getCustomer, updateCustomer } from 'admin/actions/customers';
import { testEmailAllowedLetters, validateEmail } from '~/javascripts/admin/utils/email';

const FormWrapper = styled.div`
  ${TextBox} {
    width: 400px;
  },
  ${Button} {
    margin-bottom: 20px;
  }
  ${LabeledTextBox} {
    margin-bottom: 20px;
  }
  ${TableRow} {
    width: 600px;
  }
  ${Labeled} {
    display: flex;
    margin-top: 10px;
    align-items: start;
    gap: 12px;

    > label {
      width: 160px;
      margin-top: 4px;
    }
  }
`;

// これは電話番号やメールアドレスなどをエンドユーザが移行に失敗した場合あの救済用でサービス管理者のみが使う
const SettingsCustomer = () => {
  const crumbs = [
    { value: 'ホーム', href: '/', isCurrentPage: false },
    { value: 'サービス管理', href: '', isCurrentPage: true },
    { value: 'お客様設定', href: '', isCurrentPage: true },
  ];

  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [tel, setTel] = useState('');
  const [eMail, setEMail] = useState('');
  const [creditCard, setCreditCard] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);

  const [newTel, setNewTel] = useState(null);
  const [newEMail, setNewEMail] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [emailError, setEmailError] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const setData = (customer) => {
    setName(customer.name);
    setTel(customer.tel);
    setEMail(customer.email);
    setCreditCard(customer.cards);
    setCreatedAt(moment(customer.created_at).format('YYYY-MM-DD HH:mm:ss'));
  };

  const handleSearch = (e) => {
    getCustomer(id, '').then(setData);
  };

  const onClickUpdate = () => {
    if (newEMail) {
      const isValidEmail = validateEmail(newEMail);
      if (typeof isValidEmail !== 'string') {
        setEmailError(null);
      } else {
        setEmailError(isValidEmail);
        return;
      }
    }
    openModal();
  };

  const handleUpdate = () => {
    let params = null;
    if (newTel) {
      params = Object.assign({}, params, { tel: newTel } );
    }
    if (newEMail) {
      params = Object.assign({}, params, { email: newEMail });
    }
    updateCustomer(id, params).then((customer) => {
      setData(customer);
      setMessage('変更に成功しました');
      setIsError(false);
    }).catch(e => e.then((e) => {
      setMessage(`変更に失敗しました (${e.message})`);
      setIsError(true);
    }));
    closeModal();
    setTimeout(() => setMessage(''), 10000);
  };

  const CustomerInfo = () => {
    const KeyValue = ({ title, data }) => {
      return (
        <TableRow>
          <TableCell size="3" align="left" fontWeight="600">{title}</TableCell>
          <TableCell size="9" align="left">{data}</TableCell>
        </TableRow>
      );
    };

    return (
      <div style={{ "margin-bottom": "10px" }}>
        <KeyValue title="ニックネーム" data={name} />
        <KeyValue title="携帯電話番号" data={tel} />
        <KeyValue title="メールアドレス" data={eMail} />
        <KeyValue title="クレジットカード" data={creditCard ? 'あり' : ''} />
        <KeyValue title="登録日時" data={createdAt} />
      </div>
    );
  };

  return (
    <FormWrapper>
      <BreadCrumb crumbs={crumbs} />
      <div>
        <LabeledTextBox
          labelText="お客様フルID"
          value={id}
          onBlur={v => setId(v.target.value)}
          required
        />
        <Button onClick={handleSearch}>検索</Button>
      </div>

      <Headings.h5>お客様情報</Headings.h5>
      <CustomerInfo />

      <Headings.h5>お客様設定</Headings.h5>
      <LabeledTextBox
        labelText="電話番号"
        value={newTel}
        onBlur={v => setNewTel(v.target.value)}
      />

      <LabeledTextBox
        labelText="メールアドレス"
        syncValue={newEMail}
        onChange={e => testEmailAllowedLetters(e.target.value) && setNewEMail(e.target.value)}
        errors={[emailError]}
      />
      <Button onClick={onClickUpdate}>更新</Button>
      <ConfirmModal
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        title="以下の内容で登録します"
        form={(
          <div>
            <Labeled labelText={<Headings.h6>電話番号</Headings.h6>}>{newTel}</Labeled>
            <Labeled labelText={<Headings.h6>メールアドレス</Headings.h6>}>{newEMail}</Labeled>
            <div style={{ textAlign: 'center', margin: 10 }}>
              <Button onClick={closeModal} style={{ backgroundColor: 'gray', marginLeft: 10 }} >キャンセル</Button>
              <Button onClick={handleUpdate} style={{ backgroundColor: 'red', marginLeft: 10 }} >更新</Button>
            </div>
          </div>
        )} />
      <ApiResult message={message} isError={isError} />
    </FormWrapper>
  );
};

export default SettingsCustomer;
